import Vue from 'vue';

// Element UI
import ElementUI from 'element-ui';
import '@/assets/scss/element-variables.scss';
import locale from 'element-ui/lib/locale/lang/en';

Vue.use(ElementUI, { locale });

// Vee-Validate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  locale: 'ja',
  fieldsBagName: 'veeFields',
});

// Vue clipboard 2
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);
